import React from "react";
import "./placement.css";
import placementImg from "../../assets/otherimages/placement.jpg"; // Update path if needed

function Placement() {
  return (
    <section className="placement-section">
      <div className="container">


         <section>
       <div className="headlines-for-all">
  <h4>
    <span>Placement </span> Support
  </h4>
  {/* <p>
  After completing your Software Testing course at Fazo Academy, you’ll gain access to our dedicated placement support designed to help you land your dream job as a Manual Tester or Automation Testing Engineer in top IT companies.


  </p> */}
</div>

      </section>

        <div className="placement-content">
          {/* Left Content */}
          <div className="placement-text">
            <h2 className="sub-heading">Placement Benefits</h2>
            <ul>
              <li>
                <strong>Strong Industry Network:</strong>{" "}
                <span className="fazo-fazo"><strong>Fazo Academy</strong></span> has partnerships with
                leading software companies, QA consultancies, and testing firms.
                We regularly connect our graduates to testing job opportunities
                across Chennai and India.
              </li>
              <li>
                <strong>Dedicated Placement Cell:</strong> Our placement team
                conducts exclusive recruitment drives, mock assessments, and
                coordinates interviews with top employers.
              </li>
              <li>
                <strong>Resume & LinkedIn Optimization:</strong> Get personalized
                support to create a professional resume and online profile that
                highlights your testing expertise and project experience.
              </li>
              <li>
                <strong>Career Webinars & HR Sessions:</strong> Attend sessions
                by HR experts to learn about real-world hiring trends in testing.
              </li>
            </ul>

            <h2 className="sub-heading">Interview Preparation Support</h2>
            <ul>
              <li>
                <strong>Mock Interviews:</strong> Face real-time mock interviews
                with industry experts to prepare for both technical and HR
                rounds.
              </li>
              <li>
                <strong>Automation Practice Tasks:</strong> Get guided practice
                sessions on Selenium, Postman, Jira, and other key tools.
              </li>
              <li>
                <strong>Test Scenario Workshops:</strong> Learn to design and
                execute test cases, bug reports, and automation scripts that
                impress recruiters.
              </li>
              <li>
                <strong>Continuous Mentorship:</strong> Our mentors stay in touch
                post-placement to help you adapt and grow in your QA career.
              </li>
            </ul>
          </div>

          {/* Right Image */}
          <div className="placement-image">
            <img src={placementImg} alt="Software Testing Placement Support" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Placement;
